import './styles/app.css';
//import './bootstrap'

import React from 'react';
import Calculator from "./components/calculator/calculator";

function App() {
  return (
    <Calculator />
  );
}

export default App;